import { Injectable, Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { XEVPRMMessage } from "../../../Data/Art57Data/XEVPRMMessage";
import { Art57Node } from "../Art57Node";
import { TreeNodeATCCodeList } from "../ListEntity/TreeNodeATCCodeList";
import { TreeNodeAttachmentList } from "../ListEntity/TreeNodeAttachmentList";
import { TreeNodeMasterFileLocationList } from "../ListEntity/TreeNodeMasterFileLocationList";
import { TreeNodeOrganisationList } from "../ListEntity/TreeNodeOrganisationList";
import { TreeNodePharmaceuticalFormList } from "../ListEntity/TreeNodePharmaceuticalFormList";
import { TreeNodeProductsList } from "../ListEntity/TreeNodeProductsList";
import { TreeNodeRoutesOfAdministrationList } from "../ListEntity/TreeNodeRoutesOfAdministrationList";
import { TreeNodeSourceList } from "../ListEntity/TreeNodeSourceList";
import { TreeNodeSubstancesList } from "../ListEntity/TreeNodeSubstancesList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { BaseNode } from "../../BaseNode";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { environment } from "../../../../../../environments/environment";
import { SectionName } from "../../../SectionName";


@Injectable({
    providedIn: 'root',
})
export class TreeNodeXEVPRMMessage extends Art57Node {
    constructor(private injector: Injector) {
      super(
        injector,
        new XEVPRMMessage(
          new FormGroup({}),
          new FieldDefinition(injector),
          {}
        ),
        'XEVPRM Message'
      );
  
      this.labelNodeName = 'XEVPRM Message';
      this.expanded = true;
      this.createChildTemplate();
    }
  
    reset() {
      
      this.children=[];
      this.children = (this.createChildTemplate() as Art57Node[]);
      
      this.data.model = {};
      this.refreshLabel();
  
      this.ioc!.get(LookupGetService).resetLocalNumberSequences();
  
    }
  
    override refreshLabel(): void {
      if (
        this.data &&
        this.data.model &&
        this.data.model.ichicsrmessageheader &&
        this.data.model.ichicsrmessageheader.messagenumb
      ) {
        this.label = this.data.model.ichicsrmessageheader.messagenumb;
      } else {
        this.label = this.labelTemplate;
      }
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let art57NodesTemplate: Art57Node[] = [];
  
      art57NodesTemplate.push(new TreeNodeProductsList(this.ioc!, this));
  
      if (this.ioc!.get(AuthService).isEMAOrganisation()) {
        art57NodesTemplate.push(new TreeNodeSubstancesList(this.ioc!, this));
        art57NodesTemplate.push(new TreeNodeSourceList(this.ioc!, this));
      }
      art57NodesTemplate.push(new TreeNodeOrganisationList(this.ioc!, this));
      art57NodesTemplate.push(new TreeNodeATCCodeList(this.ioc!, this));
      art57NodesTemplate.push(
        new TreeNodePharmaceuticalFormList(this.ioc!, this)
      );
      art57NodesTemplate.push(
        new TreeNodeRoutesOfAdministrationList(this.ioc!, this)
      );
      art57NodesTemplate.push(new TreeNodeAttachmentList(this.ioc!, this));
      art57NodesTemplate.push(
        new TreeNodeMasterFileLocationList(this.ioc!, this)
      );
  
      art57NodesTemplate.map((nodeToAdd) => {
        this.children?.push(nodeToAdd);
      });
  
      return art57NodesTemplate;
    }

    public entityExist(nodeList: BaseNode, code: string){ 
      const childFound: BaseNode = nodeList.children?.find(child => {
        if (child.data.model.hasOwnProperty('atccode')) {
          return child.data.model.atccode === code;
        } else {
          return child.data.model.ev_Code === code;
        }
      }) as BaseNode;
        if (childFound) {
            nodeList.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `${childFound.labelNodeName} (${code}) was already present and therefore has not been processed`, life: environment.errorElapsedTime });
        }
        return childFound != null;
    }

    /**
     * 
     * Creates a new node into Create and Send Products Report section and populates data
     * 
     * @param parentType Type of the parent
     * @param dataSource Datasource
     * @param operation  operationtype
     * @param injector   Injector
     * @param createChildTemplateparams optional parameters required in some CreateChildTemplate from Art57Nodes
     */
    createXEVPRMNode(parentType: new (...args: any[]) => any, 
                     dataSource:any, 
                     operation:number,
                     createChildTemplateparams?: any): boolean{


            let isNodeCreated:boolean=false;          
            if (dataSource.hasOwnProperty('localnumber')&&(operation===1)) { // required to create entities in create and send product report
              dataSource.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
            }
            let code = dataSource.ev_Code;
            let codeLabel = "EV Code";
            // If the node is atc, we change the code to atccode
            if (dataSource.hasOwnProperty('atccode')) {
              code = dataSource.atccode;
              codeLabel = "ATC Code";
            }
            let errorMessage = {message: `The operation cannot be perfomed on entity with ${codeLabel} ${code}`};
            if (!Art57NodeUtils.nodeCanBeLoaded(this.ioc!, operation, dataSource, errorMessage)){
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: errorMessage.message, life: environment.warningElapsedTime });
              return isNodeCreated;
            }
            const nodeList: BaseNode|null = 
                Art57NodeUtils.findFirstChildNodeOfType(this,parentType) as BaseNode|null;

            if (nodeList==null){
              return isNodeCreated;
            }

            let allowOperation: boolean = false;
            if (operation != 1) {
                allowOperation = !this.entityExist(nodeList!, code);
            } else {
                allowOperation = true;
            }

            if (allowOperation) {
                //Creates the child node
                this.ioc!.get(Art57Section).setSelectedSection(SectionName.createandsendproductreports);
                const newNode = (nodeList! as Art57Node).createChildTemplate(createChildTemplateparams)![0];
                
                //Sets the operation type
                dataSource.operationtype = operation;
                newNode.setMessage(dataSource);
                newNode.ioc!.get(Art57Section).productReports.selectedNode = newNode;
                isNodeCreated=allowOperation;
            }

            return isNodeCreated;

    }
  }